function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.11763 0.617789C4.99631 0.580459 4.86446 0.602931 4.76236 0.678345C4.66025 0.753759 4.6 0.873163 4.6 1.0001V8.92393C4.13284 8.47562 3.49859 8.2001 2.8 8.2001C1.36406 8.2001 0.199997 9.36416 0.199997 10.8001C0.199997 12.236 1.36406 13.4001 2.8 13.4001C4.23594 13.4001 5.4 12.236 5.4 10.8001C5.4 10.7518 5.39868 10.7039 5.39609 10.6563C5.39866 10.6379 5.4 10.6192 5.4 10.6001V4.74168L10.0824 6.18241C10.2037 6.21974 10.3355 6.19727 10.4376 6.12186C10.5397 6.04644 10.6 5.92704 10.6 5.8001V3.78182C10.6 2.90381 10.0274 2.12847 9.18817 1.87026L5.11763 0.617789Z",
  fill: "#212121"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 14C6 10.6863 8.68629 8 12 8C15.3137 8 18 10.6863 18 14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14ZM14.5 14C14.5 13.8199 14.4032 13.6538 14.2465 13.565L11.6198 12.0765C11.1198 11.7932 10.5 12.1544 10.5 12.7291V15.271C10.5 15.8457 11.1198 16.2068 11.6198 15.9235L14.2465 14.435C14.4032 14.3462 14.5 14.1801 14.5 14Z",
  fill: "#212121"
});

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.78d70ad1.svg";
export { ForwardRef as ReactComponent };